export const applicationStatusStyle = {
	'progressing': { color: 'darkgoldenrod', badge: 'secondary' },
	'with_editor': { color: 'blue', badge: 'primary' },
	'under_review': { color: 'blue', badge: 'primary' },
	'under_editor_evaluation': { color: 'blue', badge: 'primary' },
	'rejected': { color: 'red', badge: 'danger' },
	'completed': { color: 'green', badge: 'success' },
}

export const applicationStatus = Object.keys(applicationStatusStyle);